/**
 * Search drawer: if an exact query returns nothing (PENOLPE), retry Shopify
 * with a prefix so close style-name spellings can rank as fuzzy matches.
 */
(() => {
  let retrying = false;
  let lastPrefix = '';

  function searchRoot() {
    return document.getElementById('predictive-search');
  }

  function queryInput() {
    const form = document.getElementById('predictive-search-form');
    return form && form.elements ? form.elements.q : null;
  }

  function compactQuery(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');
  }

  async function retryWithPrefix() {
    const host = searchRoot();
    const field = queryInput();
    if (!host || !field || retrying) return;
    if (!host.querySelector('[data-search-empty]')) return;

    const original = field.value.trim();
    const compact = compactQuery(original);
    if (compact.length < 5) return;

    const prefix = compact.slice(0, Math.min(5, compact.length - 1));
    if (prefix.length < 4 || prefix === lastPrefix) return;

    retrying = true;
    lastPrefix = prefix;

    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const queries = [`${prefix}*`, prefix];

      for (const q of queries) {
        const params = new URLSearchParams({
          q,
          oq: original,
          type: 'product',
          section_id: 'predictive-search',
        });
        const response = await fetch(`${root}search?${params}`);
        if (!response.ok) continue;

        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const section = doc.querySelector('.shopify-section');
        if (!section || section.querySelector('[data-search-empty]')) continue;

        if (host.shadowRoot) host.shadowRoot.innerHTML = '<slot name="results"></slot>';
        const slot = host.querySelector('[slot="results"]');
        if (slot) slot.replaceChildren(...document.importNode(section, true).children);
        return;
      }
    } finally {
      retrying = false;
    }
  }

  document.addEventListener('theme:loading:end', () => {
    window.setTimeout(retryWithPrefix, 0);
  });

  document.addEventListener('input', (event) => {
    if (event.target && event.target.name === 'q') lastPrefix = '';
  });
})();
